import { combineReducers } from "redux";
import loadingReducer from "./loadingReducer";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import { LOGOUT } from "../types";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    users: userReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
